import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import DetailsCard from "../components/shopPartials/DetailsCard";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
import { useCart } from "../components/contexts/CartContext";
const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const ProductDetailsPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  const { cart } = useCart();
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  // useScrollToTop();
  useEffect(() => {
    let active = true;
    setLoading(true);

    axios
      .post(
        `/products/${id}${
          loggedInUser?._id ? `?customerId=${loggedInUser?._id}` : ""
        }`,
        { cartId: cart?.orderCart?._id }
      )
      .then(({ data }) => {
        if (active) setProduct(data?.item);
      })
      .catch((err) => {
        console.error(err);
        if (active)
          setError("Failed to load product details. Please try again later.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [id, cart]);
  const productContent = useMemo(
    () => product && <DetailsCard product={product} />,
    [product]
  );
  return (
    <PageWrapper loading={loading} className="">
      <Header code={discountCoupons} />
      {loading && <FullScreenLoading />}
      <BodyWrapper loading={loading} className="">
        {!loading && error ? (
          <ApiErrorMessage
            message1="Failed to load product details"
            message2="Please check your connection or try again."
          />
        ) : product ? (
          <div className={`grid grid-cols-1`}>{productContent}</div>
        ) : (
          !loading && (
            <NoItemsFound
              message1="No product details available"
              message2="Please try again later."
            />
          )
        )}
      </BodyWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default ProductDetailsPage;
